import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Body from './Body';
import Contact from './Contact';
import './App.css';


export default function App() {



  return ( 
    <body>
    <Header />
    <Body />
    <Contact />
    <Footer />
    </body>
  );
}
